import API from '../../sunwiseAPI';

export const getScheduleRateConfiguration = ({
    certified,
    rate,
    rate_division,
}) =>
    API.get(`/api/v2/schedule_rate_configuration/public/`, {
        params: { certified, rate, rate_division },
    });
